import { injectGlobal } from "styled-components"
import { above, below } from "../style/functions";

injectGlobal`
  .normal {
    text-transform: none 
  }

  .upper {
    text-transform: uppercase
  }

	.text-center-above-tablet {
      ${above.tablet`
		text-align:center;
	  `}; 		
	}

	.hide-below-tablet {
      ${below.tablet`
          display:none !important;
	  `}; 
	}
`
